module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-dcb1aaef1e677606771ee1eb4e8c488a.webp";